export const FavoriteSessionKey = 'DS_CASINO_POST_FAVORITE_ON_PAGE_LOAD';
export const SearchInitStateSessionKey = 'DS_CASINO_OPEN_SEARCH_ON_PAGE_LOAD';
export const MegaTileInitIndex = 'DS_CASINO_SET_INITIAL_ON_PAGE_LOAD';